import { CountryGroupType } from "./enums";
export const countryGroupConstraints = {
    id: {
        type: "string",
    },
    networkId: {
        type: "string",
        presence: true,
    },
    name: {
        type: "string",
        presence: true,
    },
    selectedCountries: {
        type: "array",
        presence: true,
    },
    type: {
        enum: CountryGroupType,
        presence: true,
    },
};
